import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-gray-50 font-poppins">
      <div className="container mx-auto px-4 py-12">
        <div className="bg-white p-10 rounded-xl shadow-lg">
          <h1 className="text-4xl font-bold mb-8 text-gray-900 border-b pb-4">
            Privacy Policy
          </h1>
          <h1 className="text-4xl font-bold mb-8 text-gray-900 border-b pb-4">
            🚨 PLACEHOLDER 🚨
          </h1>

          <div className="space-y-8 text-gray-700">
            <div className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Introduction
              </h2>
              <p>
                Welcome to Envolvly! We are committed to protecting your
                privacy. This Privacy Policy explains how we collect, use,
                disclose, and safeguard your information when you use our
                platform.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Information We Collect
              </h2>
              <p>
                We may collect personal information from you in a variety of
                ways, including, but not limited to, when you create an account,
                make a purchase, or interact with our services. The types of
                personal information we may collect include your name, email
                address, and payment information.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                How We Use Your Information
              </h2>
              <p>
                We use the information we collect to provide, operate, and
                maintain our services. This includes using your information to
                process transactions, send you promotional communications, and
                improve our platform.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                How We Share Your Information
              </h2>
              <p>
                We do not sell, trade, or otherwise transfer to outside parties
                your Personally Identifiable Information unless we provide users
                with advance notice. This does not include website hosting
                partners and other parties who assist us in operating our
                website, conducting our business, or serving our users, so long
                as those parties agree to keep this information confidential.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">Security</h2>
              <p>
                The security of your personal information is important to us. We
                use a variety of security technologies and procedures to help
                protect your personal information from unauthorized access, use,
                or disclosure.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Changes to This Policy
              </h2>
              <p>
                We may update this Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page. You are advised to review this Privacy Policy
                periodically for any changes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
